// extracted by mini-css-extract-plugin
module.exports = {"resetDetails":"ForgotPassword_resetDetails___y1SB","resetButton":"ForgotPassword_resetButton__PoQmv","login":"ForgotPassword_login__naQWY"};